export default __webpack_public_path__ + "static/media/chelavara.7d634c74.jpg";